<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">

	<div>
		<v-dialog
			persistent
			v-model="showDialog"
			width="500">
			<template v-slot:activator="{ on }">
				<v-btn
					class="blue"
					v-on="on">
					Dołącz umowę
				</v-btn>
			</template>
			<v-card>
				<v-form ref="form">
					<v-card-title
						class="headline"
						primary-title
					>
						Dołączenie umowy
					</v-card-title>
					<v-card-text>
						<v-flex xs12>
							<v-menu
								ref="menu"
								v-model="menu"
								:close-on-content-click="false"
								:return-value.sync="agreement.signDate"
								transition="scale-transition"
								offset-y
								full-width
								min-width="290px"
							>
								<template v-slot:activator="{ on }">
									<v-text-field
										browser-autocomplete="off"
										v-model="agreement.signDate"
										label="Data podpisania"
										aria-label="sign date"
										for="agreement-popup-date-sign"
										id="agreement-popup-date-sign"
										:rules="rules"
										prepend-icon="event"
										readonly
										v-on="on"
									></v-text-field>
								</template>
								<v-date-picker :first-day-of-week="1"
									v-model="agreement.signDate" no-title scrollable locale="pl-PL">
									<v-spacer></v-spacer>
									<v-btn text color="primary" @click="menu = false">Anuluj</v-btn>
									<v-btn text color="primary" @click="$refs.menu.save(agreement.signDate)">OK</v-btn>
								</v-date-picker>
							</v-menu>
						</v-flex>
						<br/>
						<v-flex xs12>
							<v-text-field
								browser-autocomplete="off"
								label="Numer umowy (numer BDG)"
								aria-label="agreement number"
								for="agreement-popup-number-sign"
								id="agreement-popup-number-sign"
								:rules="rules"
								v-model="agreement.number">
							</v-text-field>
						</v-flex>
						<v-flex xs12>
							<div v-show="errorMessage" style="color: red" class="ml-2">
								{{errorMessage}}
							</div>
						</v-flex>
						<v-flex xs12>
							<v-layout row>
								<v-flex xs6>
									<v-btn @click="$refs.file.click()" class="ma-2">
										{{'Dodaj umowę'}}
									</v-btn>
								</v-flex>
								<v-flex xs6>
									<v-btn @click="$refs.attachments.click()" class="ma-2">
										{{'Dodaj załączniki'}}
									</v-btn>
								</v-flex>
							</v-layout>
						</v-flex>
						<input :rules="rules" type="file" v-show="false" ref="file" id="agreement-file-input"
							:accept="acceptedFiles"
							v-on:change="handleAgreementUpload">
						<input :rules="rules" type="file" multiple v-show="false" ref="attachments"
							:accept="acceptedFiles"
							id="agreement-attachments-input"
							v-on:change="handleAttachmentsUpload">
						<div v-if="agreement.file">
							<strong class="mr-2">Umowa: </strong>{{agreement.file.name}}
							<v-icon @click="deleteAgreementFile" style="cursor: pointer" class="ml-2">delete</v-icon>
						</div>
						<div v-for="(item, index) in agreement.attachments" :key="index">
							<strong class="mr-2">{{'Załącznik ' + (index + 1)}}:</strong>
							{{item.name}}
							<v-icon @click="deleteAttachment(index)" style="cursor: pointer" class="ml-2">delete
							</v-icon>
						</div>

					</v-card-text>
					<v-divider></v-divider>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn
							color="primary"
							flat
							@click="closeModal">
							Anuluj
						</v-btn>
						<v-btn
							color="primary"
							@click="addAgreement">
							Zapisz
						</v-btn>
					</v-card-actions>
				</v-form>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
	import {Files} from "../../../../utils/Files";

	export default {
		name: "AgreementPopup",

		data() {
			return {
				showDialog: false,
				agreement: {
					number: null,
					signDate: null,
					file: null,
					attachments: [],
				},
				errorMessage: null,
				menu: false,

				rules: [v => !!v || "Pole wymagane!"],
			};
		},

		methods: {
			closeModal() {
				this.showDialog = false;
				this.agreement = {
					number: null,
					signDate: null,
					file: null,
					attachments: [],
				};
				this.errorMessage = null;
			},
			validate () {

				if (!this.$refs.form.validate() || !this.validateAgreementFile()) {
					return false;
				} else {
					return true;
				}
			},
			async postAgreement () {
				let formData = new FormData();
				formData.append("file", this.agreement.file);
				for (let i = 0; i < this.agreement.attachments.length; ++i) {
					formData.append("attachments", this.agreement.attachments[i]);
				}
				await this.$http.post(process.env.VUE_APP_API_URL + "/project/agreement?projectId="
					.concat(this.$route.params.projectId)
					.concat("&signDate=").concat(this.agreement.signDate)
					.concat("&number=").concat(this.agreement.number), formData, {
					headers: {
						"Content-Type": "multipart/form-data",
					},
				});
				this.$emit("refresh");
				this.closeModal();
			},
			async addAgreement () {
				if (this.validate()) {
					this.$confirm("Upewnij się, że załączone pliki są prawidłowe. Po zapisaniu nie będzie możliwości ich usunięcia. Czy chcesz kontynuować?",
						{
							icon: "info",
							color: "primary",
							width: 500,
							title: "Potwierdź dołączenie umowy",
						}).then(response => {
						if (response) {
							this.postAgreement();
						}
					});
				}
			},
			async handleAttachmentsUpload() {
				if (this.hasIncorrectFilesExtension(this.$refs.attachments.files)) {
					Files.methods.clearFileInput('agreement-attachments-input');
          this.$messagesBus.$emit("error", "Wgrywanie plików w tym formacie jest niedozwolone. " +
              "Dozwolone formaty plików to " + this.acceptedFiles.split(",").join(", "));
          return;
				}

				let validFilesSize = await Files.methods.validateFilesSize(this, this.$refs.attachments.files);
				if (!validFilesSize) {
					Files.methods.clearFileInput('agreement-attachments-input');
					return;
				}
				for (let i = 0; i < this.$refs.attachments.files.length; ++i) {
					this.agreement.attachments.push(this.$refs.attachments.files[i]);
				}
			},
			async handleAgreementUpload() {
				if (this.hasIncorrectFilesExtension(this.$refs.file.files)) {
					Files.methods.clearFileInput('agreement-file-input');
          this.$messagesBus.$emit("error", "Wgrywanie plików w tym formacie jest niedozwolone. " +
              "Dozwolone formaty plików to " + this.acceptedFiles.split(",").join(", "));
          return;
				}
				let validFilesSize = await Files.methods.validateFilesSize(this, this.$refs.file.files);
				if (!validFilesSize) {
					Files.methods.clearFileInput('agreement-file-input');
					return;
				}
				this.agreement.file = this.$refs.file.files[0];
				this.errorMessage = null;
			},
			deleteAgreementFile() {
				this.agreement.file = null;
			},
			deleteAttachment(index) {
				this.agreement.attachments.splice(index, 1);
			},
			validateAgreementFile() {
				if (this.agreement.file === null) {
					this.errorMessage = "Należy dodać umowę!";
					return false;
				} else {
					this.errorMessage = "";
					return true;
				}
			}
		},

		props: {
			project: {
				type: Object
			}
		},
	};
</script>

<style scoped>

</style>
